// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-Qbezq {
  background-color: #ff7f50;
}
.debug2-rId0e {
  background-color: #6495ed;
}
.specialexcursion-x6HlC {
  width: 100%;
}
.specialexcursion-x6HlC .title-UTT4i {
  font-size: 1.125em;
  font-family: "AvenirBook";
}
.specialexcursion-x6HlC .sessions-kFT3v {
  display: flex;
  align-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
  margin: 10px 0px;
}
.specialexcursion-x6HlC .sessions-kFT3v .session-RE4qR {
  text-wrap: none;
  padding: 10px;
  font-size: 0.9375em;
  font-family: "AvenirBook";
  background-color: #33CCFF;
  border-radius: 15px;
  text-align: center;
  color: #FFFFFF;
  cursor: pointer;
}
.specialexcursion-x6HlC .sessions-kFT3v .sessionselected-TPLQA {
  text-wrap: none;
  padding: 10px;
  font-size: 0.9375em;
  font-family: "AvenirBook";
  background-color: #33CCFF;
  border-radius: 15px;
  text-align: center;
  color: #FFFFFF;
  cursor: pointer;
  background-color: #FF6698;
}
.specialexcursion-x6HlC .sessions-kFT3v .sessiondisable-eVzE5 {
  text-wrap: none;
  padding: 10px;
  font-size: 0.9375em;
  font-family: "AvenirBook";
  background-color: #33CCFF;
  border-radius: 15px;
  text-align: center;
  color: #FFFFFF;
  cursor: pointer;
  background-color: #999999;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/components/VTForm/components/VTEspecialExcursion/Excursions/2060/excursion.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA/BA;EAAmB,WAAA;AAkCnB;AAlCA;ECsCE,kBAAA;EDrCwB,yBAAA;AAqC1B;AAtCA;EAEY,aAAA;EAAc,yBAAA;EAA0B,SAAA;EAAW,eAAA;EAAiB,gBAAA;AA2ChF;AA7CA;EAGa,eAAA;EAAgB,aAAA;ECmC3B,mBAAA;EDnCyD,yBAAA;EAA0B,yBAAA;EAA8B,mBAAA;EAAqB,kBAAA;EAAqB,cAAA;EAAe,eAAA;AAqD5K;AAxDA;EAGa,eAAA;EAAgB,aAAA;ECmC3B,mBAAA;EDnCyD,yBAAA;EAA0B,yBAAA;EAA8B,mBAAA;EAAqB,kBAAA;EAAqB,cAAA;EAAe,eAAA;EAC7I,yBAAA;AAgE/B;AApEA;EAGa,eAAA;EAAgB,aAAA;ECmC3B,mBAAA;EDnCyD,yBAAA;EAA0B,yBAAA;EAA8B,mBAAA;EAAqB,kBAAA;EAAqB,cAAA;EAAe,eAAA;EAE9I,yBAAA;EAA8B,eAAA;AA4E5D","sourcesContent":["@import \"../../../../../../assets/css/theme\";\n\n.specialexcursion {width:100%;\n  .title{ .font-base(18); font-family:\"AvenirBook\";}\n  .sessions{display:flex; align-content:flex-start; gap: 20px; flex-wrap: wrap; margin: 10px 0px;\n    .session{text-wrap:none; padding:10px; .font-base(15); font-family:\"AvenirBook\"; background-color:@colorazul1; border-radius: 15px; text-align: center;  color:#FFFFFF; cursor:pointer; }\n    .sessionselected{.session; background-color:@colorrosa1;}\n    .sessiondisable{.session; background-color:@colorgris2; cursor:default;}\n  }\n\n}\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-Qbezq`,
	"debug2": `debug2-rId0e`,
	"specialexcursion": `specialexcursion-x6HlC`,
	"title": `title-UTT4i`,
	"sessions": `sessions-kFT3v`,
	"session": `session-RE4qR`,
	"sessionselected": `sessionselected-TPLQA`,
	"sessiondisable": `sessiondisable-eVzE5`
};
export default ___CSS_LOADER_EXPORT___;
